// src/Pages/Usuario/Agenda/components/DatosPaciente.jsx

import React, { useState } from "react";

export default function DatosPaciente({
  usuario,
  form,
  setForm,
  mostrarDatos,
  setMostrarDatos,
  handleChange,
  crearCuenta,
  handleGoogleSignup,
}) {
  
  const [showCredsSignup, setShowCredsSignup] = useState(false);

  // Manejo especial del campo teléfono
  const handleTelefono = (e) => {
    let v = e.target.value;

    if (!v.startsWith("+569")) {
      const nums = v.replace(/[^0-9]/g, "");
      if (nums.startsWith("569")) v = "+569" + nums.slice(3);
      else v = "+569" + nums;
    }

    setForm((prev) => ({ ...prev, celular: v }));
  };

  // Manejo especial del teléfono emergencia
  const handleTelefonoEmergencia = (e) => {
    let v = e.target.value;

    if (!v.startsWith("+569")) {
      const nums = v.replace(/[^0-9]/g, "");
      if (nums.startsWith("569")) v = "+569" + nums.slice(3);
      else v = "+569" + nums;
    }

    setForm((prev) => ({ ...prev, t_emergencia: v }));
  };

  
  return (
    <div className="bg-white/80 backdrop-blur-xl rounded-2xl shadow-[0_18px_50px_-22px_rgba(58,106,255,0.35)] border border-blue-100 overflow-hidden">

      {/* HEADER */}
      <button
        onClick={() => setMostrarDatos((v) => !v)}
        className="w-full flex items-center justify-between px-5 py-4 text-left bg-blue-50/40 hover:bg-blue-50/70 transition"
      >
        <div className="flex items-center gap-3">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#00698F] text-white font-bold">
            1
          </span>
          <div>
            <div className="font-semibold text-[#00698F]">Tus datos</div>
            <div className="text-xs text-gray-500">
              Se usarán para tu reserva y boleta.
            </div>
          </div>
        </div>

        <span className="text-[#00698F] text-sm">
          {mostrarDatos ? "Ocultar" : "Mostrar"}
        </span>
      </button>

      {/* CONTENIDO */}
      <div
        className={`transition-all duration-300 overflow-hidden ${
          mostrarDatos ? "max-h-[3000px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="p-5">

          {/* GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {/* NOMBRE */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Nombre <span className="text-red-500">*</span>
              </label>
              <input
                name="nombres"
                value={form.nombres}
                onChange={handleChange}
                placeholder="Ej: Paula"
                className="w-full border border-gray-300 rounded-xl px-3 py-2"
              />
            </div>

            {/* APELLIDO */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Apellido <span className="text-red-500">*</span>
              </label>
              <input
                name="apellidos"
                value={form.apellidos}
                onChange={handleChange}
                placeholder="Ej: Montes"
                className="w-full border border-gray-300 rounded-xl px-3 py-2"
              />
            </div>

            {/* RUT */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                RUT <span className="text-red-500">*</span>
              </label>
              <input
                name="rut"
                value={form.rut}
                onChange={handleChange}
                placeholder="Ej: 12345678-9"
                className="w-full border border-gray-300 rounded-xl px-3 py-2"
              />
            </div>

            {/* CORREO */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Correo electrónico <span className="text-red-500">*</span>
              </label>
              <input
                name="correo"
                type="email"
                value={form.correo}
                onChange={handleChange}
                placeholder="correo@ejemplo.com"
                className="w-full border border-gray-300 rounded-xl px-3 py-2"
              />
            </div>

            {/* TELEFONO */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Teléfono <span className="text-red-500">*</span>
              </label>
              <input
                name="celular"
                value={form.celular}
                onChange={handleTelefono}
                onKeyDown={(e) => {
                  const cursor = e.target.selectionStart;
                  if (cursor <= 4 && (e.key === "Backspace" || e.key === "Delete"))
                    e.preventDefault();
                }}
                placeholder="+569XXXXXXXX"
                className="w-full border border-gray-300 rounded-xl px-3 py-2"
              />
            </div>

            {/* EMERGENCIA: TELEFONO */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray-700 mb-1">
                Teléfono de emergencia
              </label>
                <input
                  name="t_emergencia"
                  value={form.t_emergencia}
                  onChange={handleTelefonoEmergencia}
                  placeholder="+569XXXXXXXX"
                  className="w-full border border-gray-300 rounded-xl px-3 py-2"
                />
            </div>
          </div>

          {/* CREAR CUENTA SI NO ESTÁ LOGUEADO */}
          {!usuario && (
            <div className="mt-6">
              <div className="text-sm text-gray-700 font-medium mb-3">
                Para reservar debes registrarte o iniciar sesión
              </div>

              {/* ✅ GOOGLE PRIMERO */}
              <button
                type="button"
                onClick={() => {
                  setShowCredsSignup(false);
                  handleGoogleSignup();
                }}
                className="w-full bg-red-500 hover:bg-red-600 text-white py-3 rounded-xl font-semibold transition"
              >
                Registrarse con Google
              </button>

              {/* Divider */}
              <div className="flex items-center my-5">
                <hr className="flex-grow border-gray-300" />
                <span className="mx-4 text-gray-500 text-sm">o</span>
                <hr className="flex-grow border-gray-300" />
              </div>

              {/* ✅ BOTÓN QUE DESPLIEGA REGISTRO CON CREDENCIALES */}
              <button
                type="button"
                onClick={() => setShowCredsSignup((v) => !v)}
                className="
                  w-full py-3 rounded-xl
                  bg-[#00698f] text-white font-semibold
                  hover:bg-[#0089C4] transition
                "
              >
                {showCredsSignup
                  ? "Ocultar registro con correo y contraseña"
                  : "Registrarse con correo y contraseña"}
              </button>

              {/* ✅ PANEL DESPLEGABLE (tu “segunda captura”) */}
              <div
                className={`
                  overflow-hidden transition-all duration-300
                  ${showCredsSignup ? "max-h-[520px] opacity-100 mt-4" : "max-h-0 opacity-0 mt-0"}
                `}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex flex-col">
                    <label className="text-sm font-medium text-gray-700 mb-1">
                      Contraseña <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="password"
                      name="password"
                      value={form.password}
                      onChange={handleChange}
                      placeholder="Mínimo 6 caracteres"
                      required={showCredsSignup}
                      className="w-full border border-gray-300 rounded-xl px-3 py-2"
                    />
                  </div>

                  <div className="flex flex-col">
                    <label className="text-sm font-medium text-gray-700 mb-1">
                      Repetir contraseña <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="password"
                      name="confirmPassword"
                      value={form.confirmPassword}
                      onChange={handleChange}
                      placeholder="Repite la contraseña"
                      required={showCredsSignup}
                      className="w-full border border-gray-300 rounded-xl px-3 py-2"
                    />
                  </div>

                  <button
                    type="button"
                    onClick={crearCuenta}
                    className="md:col-span-2 py-3 px-4 rounded-xl bg-[#00698f] text-white font-semibold hover:bg-[#0089C4] transition"
                  >
                    Crear cuenta
                  </button>
                </div>

                <p className="mt-3 text-xs text-gray-500">
                  Para continuar con la reserva necesitas crear tu cuenta.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
